import type { A2uiSurfaceAdapterRovoMessage } from '@atlassian/a2ui-renderer-next/v0_9/a2ui-surface-adapter-rovo';

import { type A2UIMessageRecord } from './surfaceIdOf';

/** A v0.9 `createSurface`, or the v0.8 `beginRendering` that opens a surface the same way. */
export const isCreateSurface = (a2uiMessage: A2uiSurfaceAdapterRovoMessage): boolean => {
	const wire = a2uiMessage as A2UIMessageRecord;
	return (
		wire.createSurface !== undefined ||
		wire.beginRendering !== undefined ||
		wire.type === 'createSurface'
	);
};
